import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { CampiService } from 'src/app/services/campi.service';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dettaglio-campo',
  templateUrl: './dettaglio-campo.component.html',
  styleUrls: ['./dettaglio-campo.component.css']
})
export class DettaglioCampoComponent implements OnInit {

  @ViewChild('valorecambiato') inputValore: ElementRef<HTMLInputElement>;
  selectedTipo: number;
  public toolbar: Toolbar;
  public editToolbar: Toolbar;
  public form: FormGroup;
  public isModifica: boolean = false;
  public isDettaglio: boolean = false;
  //datasource della tabella dell'elenco valori per i campi TENDINA
  public elencoValoriDataSource: MatTableDataSource<string> = new MatTableDataSource();
  //Array che riempie il dataSource
  private privElencoValoriArr: string[] = [];
  //Opzioni dei campi a tendina salvati come stringa (per controllo)
  private listaValori: string = "";
  public showListaEditabileValori: boolean = false;
  public idCampo: number;
  public idTemplate: number;
  public tpModulo: number;
  public oldOrdinamento: number = 1;
  public flagVisibilita: string = '';
  nomeCampo: string;
  descrizione: string;
  obbligatorio: string;
  idTpCampoModulo: number;
  predefinito: boolean;
  // opzioni: string; -> per ora disattivato
  opzioniList: ModelEventiCalamitosi.Opzione[];
  predefiniti: boolean;
  acl: string;
  //colonne della tabella dei valori possibili per un campo a tendina
  colonneTableValori: string[] = ["nomeValori", "actions"];
  colonneTableValorDescr: string[] = ["nomeValori"];
  openToggle: number = -1;

  //  il campo modeSaveSelection è un flag che ci indica se:
  //- l'inserimento che si vuole effettuare è del primo campo di un template (es. primo campo di un template libero o la normale aggiunta) ---> false
  //- l'inserimento che si vuole effettuare è di un campo che si vuole inserire in mezzo ad altri già preesistenti ---> (Sviluppi FASE2) true
  private modeSaveSelection:boolean = false;

  //il campo idCampoPrecedente serve per la creazione di un campo subito sotto ad un altro
  //serve al BE per effettuare controlli e l'operazione di switch di tutti gli altri campi
  private idCampoPrecedente:number = 0;


  constructor(
    private dialogRef: MatDialogRef<DettaglioCampoComponent>,
    private campiSvc: CampiService,
    private alertsCenterService: AlertsCenterService,
    @Inject(Router) private router: Router,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.acl = sessionStorage.getItem("acl");
    this.predefiniti = data.predefiniti;
    this.modeSaveSelection = data.modeSaveSelection;
    this.idCampoPrecedente = data.idCampoPrecedente;

    if (data.idCampo != '' || data.tpModulo != '' || data.idTemplate != '') {

      this.idCampo = data.idCampo;
      this.idTemplate = data.idTemplate;
      this.tpModulo = data.tpModulo;

      if (data.tipoVista == 'detail') {
        this.isDettaglio = true;
        this.isModifica = false;
      } else if (data.tipoVista == 'edit') {
        this.isModifica = true;
        this.isDettaglio = false;
      }
      this.setUpComponent();
    }

    this.editToolbar = {
      toolbarCss: 'toolbar-vertical',
      actions: [
        {
          btnTitle: 'Salva modifiche',
          btnIconClass: 'save',
          btnActionEvent: 'edit-valore',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Annulla modifiche',
          btnIconClass: 'settings_backup_restore',
          btnActionEvent: 'back',
          btnCssClass: 'btn btn-secondary'
        },
      ]
    }

    this.toolbar = {
      toolbarCss: 'toolbar-vertical',
      actions: [
        {
          btnTitle: 'Modifica',
          btnIconClass: 'create',
          btnActionEvent: 'edit',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Elimina',
          btnIconClass: 'delete',
          btnActionEvent: 'remove',
          btnCssClass: 'btn btn-secondary eliminaVal'
        },
        {
          btnTitle: 'Sposta su',
          btnIconClass: 'keyboard_arrow_up',
          btnActionEvent: 'up',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Sposta giù',
          btnIconClass: 'keyboard_arrow_down',
          btnActionEvent: 'down',
          btnCssClass: 'btn btn-primary'
        }
      ]
    }
  }

  ngOnInit() {

  }

  setUpComponent() {

    this.buildForm();

    if (this.isDettaglio || this.isModifica) {

      this.campiSvc.getCampo(this.idCampo, this.idTemplate, this.tpModulo).toPromise().then(result => {
        this.flagVisibilita = result.flVisibilita;
        this.oldOrdinamento = result.ordinamento;
        this.selectedTipo = result.idTpCampoModulo;

        if (this.selectedTipo == 4 || this.selectedTipo == 7) {
          this.showListaEditabileValori = true;
        }

        this.nomeCampo = result.nomeCampo;
        this.descrizione = result.descrizione;
        this.obbligatorio = result.obbligatorio;
        this.idTpCampoModulo = result.idTpCampoModulo;
        this.predefinito = result.predefinito == 'S';
        // this.opzioni = result.opzioni;
        this.opzioniList = result.opzioniList;
        if (this.opzioniList === undefined || this.opzioniList === null || this.opzioniList.length == 0) {
          this.listaValori = "";
        } else {
          this.privElencoValoriArr = result.opzioniList.map(val => {
            return val.valore
          })
          this.listaValori = this.privElencoValoriArr.join("|");
          this.elencoValoriDataSource.data = this.privElencoValoriArr;
        }
      }).then(() => {
        // modifica.
        this.form = new FormGroup({
          nomeCampo: new FormControl({ value: this.nomeCampo, disabled:this.isDettaglio && !this.isModifica }, [Validators.required, Validators.maxLength(30), Validators.pattern("^[a-zA-Z0-9_]*$")]),
          descrizione: new FormControl({ value: this.descrizione, disabled: this.isDettaglio && !this.isModifica }, [Validators.required, Validators.maxLength(2000)]),
          obbligatorio: new FormControl({ value: this.obbligatorio, disabled: this.isDettaglio && !this.isModifica }, [Validators.required]),
          idTpCampoModulo: new FormControl({ value: this.selectedTipo, disabled:this.isDettaglio && !this.isModifica }, [Validators.required]),
          valore: new FormControl({value:'', disabled:this.isDettaglio && !this.isModifica },  [Validators.pattern("[^|]+")]),
          // elencoValori: new FormControl({ value: this.listaValori, disabled: true }, null)
        });

      }).then(x => {
        this.form.get('idTpCampoModulo').valueChanges.subscribe(
          selectedValue => {
            if (selectedValue == 4 || selectedValue == 7) {
              this.showListaEditabileValori = true;
            } else {
              this.showListaEditabileValori = false;
            }
          }
        )
      })
    if (this.isDettaglio || this.isModifica) {
      this.form.get('idTpCampoModulo').disable();
    }
    }

    this.form.get('idTpCampoModulo').valueChanges.subscribe(
      selectedValue => {
        if (selectedValue == 4 || selectedValue == 7) {
          this.showListaEditabileValori = true;
        } else {
          this.showListaEditabileValori = false;
        }
      }
    )
  }
// form new.
  buildForm() {
    this.form = new FormGroup({
      nomeCampo: new FormControl({value:null, disabled: this.isDettaglio && this.isModifica }, [Validators.required, Validators.pattern("^[a-zA-Z0-9_]*$"), Validators.maxLength(30)]),
      descrizione: new FormControl('', [Validators.required, Validators.maxLength(2000)]),
      obbligatorio: new FormControl({ value: 'N' , disabled: this.isDettaglio && !this.isModifica}, [Validators.required]),
      idTpCampoModulo: new FormControl({ value: null, disabled: this.isDettaglio && !this.isModifica }, [Validators.required]),
      valore: new FormControl('', [Validators.pattern("[^|]+")]),
      // elencoValori: new FormControl({ value: null, disabled: true }, null)
    });
  }

  addValue() {
    let valore: string = this.form.get('valore').value;
    if (valore.trim() != '' && !valore.includes("|")) {
      if (!this.privElencoValoriArr.includes(valore)) {
        this.listaValori = this.listaValori.concat("|").concat(valore)
        // let listaValoriToPrint = this.listaValori.split("|").join("\n");
        this.privElencoValoriArr.push(valore);
        // this.form.get('elencoValori').setValue(listaValoriToPrint);
        this.form.get('valore').reset('');
        this.elencoValoriDataSource.data = this.privElencoValoriArr;
      } else {
        this.alertsCenterService.showAlert({
          message: `Valore già inserito nell'elenco dei valori`,
          type: 'danger',
          autoClosable: false
        });
      }
    } else {
      this.form.markAsTouched();
      this.alertsCenterService.showAlert({
        message: `Inserire un valore corretto nell'elenco dei valori`,
        type: 'danger',
        autoClosable: false
      });
    }
  }

  saveCampo() {

    let newCampo: ModelEventiCalamitosi.CampoModuloDTO = {
      idCampo: this.idCampo,
      idTemplate: this.idTemplate,
      tpModulo: this.tpModulo,
      ordinamento: this.oldOrdinamento,
      obbligatorio: this.form.controls.obbligatorio.value,
      flVisibilita: this.flagVisibilita === '' ? 'S' : this.flagVisibilita,
      nomeCampo: this.form.controls.nomeCampo.value,
      descrizione: this.form.controls.descrizione.value,
      idTpCampoModulo: this.form.controls.idTpCampoModulo.value,
      opzioniDaFe: this.privElencoValoriArr.join("|"),
      lunghezza: 65536,
      predefinito: this.predefinito ? 'S' : 'N', //in base al parametro in entrata della modal
      modeSaveSelection:this.modeSaveSelection,
      idCampoPrecedente:this.idCampoPrecedente
    }
    newCampo.campoDgpe = this.acl.includes(AclTipo.DGPE) ? "S" : "N";

    if (!this.isDettaglio) {
          if (!this.form.controls.nomeCampo.errors && !this.form.controls.descrizione.errors && !this.form.controls.obbligatorio.errors && !this.form.controls.idTpCampoModulo.errors) {

            if(newCampo.idTpCampoModulo == 4 || newCampo.idTpCampoModulo == 7) {
              if(this.privElencoValoriArr.length < 1) {
                this.alertsCenterService.showAlert({
                  message: `E' necessario aggiungere almeno un'opzione selezionabile per il campo`,
                  type: 'danger',
                  autoClosable: false
                });

                  console.log("*** chiamo upsertCampo:", newCampo);
                return;
              }
            }

              console.log("*** chiamo upsertCampo:", newCampo);
                  this.campiSvc.upsertCampo(newCampo).toPromise().then(res => {
                    this.alertsCenterService.showAlert({
                      message: `Salvataggio del campo effettuato con successo`,
                      type: 'success',
                      autoClosable: false
                    });
                    this.dialogRef.close(true);
                  },
                    err => {
                      this.alertsCenterService.showAlert({
                        message: err.error.esitoServizio.descrizioneEsito,
                        type: 'danger',
                        autoClosable: false
                      });
                      this.dialogRef.disableClose = false;
                    });
                }
                this.form.controls.nomeCampo.markAsTouched();
                this.form.controls.idTpCampoModulo.markAsTouched();
                this.dialogRef.disableClose = false;
   }
  }

  public handleToolbarEvent(event: ToolbarEvent, index: number): void {
    if (event.event === 'remove') {
      this.privElencoValoriArr.splice(index, 1);
      this.listaValori = this.privElencoValoriArr.join("|");
      this.elencoValoriDataSource.data = this.privElencoValoriArr;
    }
    else if (event.event === 'up' || event.event === 'down') {
      let direzione: string = event.event;
      this.elencoValoriDataSource.data = this.changeOrdElencoVal(direzione, index);
    } else if (event.event === 'edit') {
      this.openToggle = index
    } else if (event.event === 'back') {
      this.openToggle = -1
    }
    //caso modifica valore
    else if (event.event === 'edit-valore') {
      //prendo l'input direttamente dall'elemento html
      let valore: string = this.inputValore.nativeElement.value;
      //controlli vari
      if (valore != '') {
        if (!this.privElencoValoriArr.includes(valore)) {
          this.listaValori = this.listaValori.concat("|").concat(valore)
          this.privElencoValoriArr.splice(index, 1, valore);
          this.elencoValoriDataSource.data = this.privElencoValoriArr;
          this.openToggle = -1
        } else {
          this.alertsCenterService.showAlert({
            message: `Valore già inserito nell'elenco dei valori`,
            type: 'danger',
            autoClosable: false
          });
        }
      } else {
        this.alertsCenterService.showAlert({
          message: `Inserire un valore corretto nell'elenco dei valori`,
          type: 'danger',
          autoClosable: false
        });
      }
    }

  }

  private changeOrdElencoVal(direzione: string, indexElemento: number): string[] {

    if ((indexElemento === 0 && direzione === 'up') || (indexElemento === this.privElencoValoriArr.length - 1 && direzione === 'down')) {
      this.alertsCenterService.showAlert({
        message: `Impossibile spostare il campo nella posizione scelta`,
        type: 'danger',
        autoClosable: false
      });
    } else {
      //Salvo l'indice e l'elemento successivo/precedente a quello che desidero spostare in base alla direzione
      //Effettuo la sostituzione dell'elemento e restituisco il nuovo array con l'ordinamento scelto
      let indexElementoTemp: number = indexElemento;

      if (direzione === 'up') indexElementoTemp--
      else indexElementoTemp++

      let elementoTemp = this.privElencoValoriArr[indexElementoTemp];

      this.privElencoValoriArr.splice(indexElementoTemp, 1, this.privElencoValoriArr[indexElemento])
      this.privElencoValoriArr.splice(indexElemento, 1, elementoTemp);
    }

    return this.privElencoValoriArr
  }


}


